/**
 * Telemetry Module Exports
 * 
 * This module provides telemetry and logging capabilities for the Angular application.
 * 
 * Services:
 * - TelemetryLoggerService: Main logging service for sending logs to backend
 * - CorrelationIdService: Manages correlation IDs for tracking related operations
 * - GlobalErrorHandler: Custom error handler for uncaught exceptions
 * 
 * Usage:
 * ```typescript
 * import { TelemetryLoggerService, CorrelationIdService } from './core/services/telemetry';
 * ```
 */

export { TelemetryLoggerService, ScopedLogger } from './telemetry-logger.service';
export type { 
  LogLevel, 
  ErrorInfo, 
  UILogPayload, 
  BatchLogsPayload, 
  TelemetryLoggerConfig 
} from './telemetry-logger.service';

export { CorrelationIdService } from './correlation-id.service';
export type { ModuleMapping } from './correlation-id.service';

export { GlobalErrorHandler, setupGlobalErrorListeners } from './global-error-handler.service';

